/**
 * SNOMED CT measurement code → display name, ported from the Retool
 * `getMeasurementName.js` transformer (EN-5149). The same lookup is copied
 * into three Retool apps — Jupyter Integration, eMED Beaumont Integration and
 * Measurements — so it lives here once for the pages that migrate later.
 *
 * ⚠️ It does NOT apply to Jupyter's `scopeCode`: those are OMH scope codes
 * (`omh:oxygen-saturation:2.0`), not SNOMED codes. The transformer only sits
 * in that Retool app because the page was cloned from eMED Beaumont — the
 * page's own tables never call it.
 *
 * Two codes map to "Total Cholesterol" in the source list; both are kept so
 * either resolves.
 */
const MEASUREMENT_NAMES_BY_CODE: Record<string, string> = {
  "250271003": "White cells",
  "365760004": "Potassium",
  "391379002": "Tacrolimus Level (Prograf)",
  "708157004": "BK virus DNA",
  "365793008": "Total Cholesterol",
  "121868005": "Total Cholesterol",
  "28036006": "HDL Cholesterol",
  "113079009": "LDL Cholesterol",
  "71878006": "Calcium",
  "443796007": "Corrected Calcium",
  "365756002": "Creatinine",
  "250220000": "Hemoglobin",
  "104866001": "Phosphate",
  "365811003": "Plasma Glucose",
  "80274001": "labGFR",
  "30630007": "Neutrophils",
};

/**
 * Display name for a SNOMED measurement code, or `undefined` when the code
 * isn't in the catalogue — callers decide whether to fall back to the raw
 * code or hide the label.
 */
export function getMeasurementName(
  code: string | number | null | undefined
): string | undefined {
  if (code === null || code === undefined) return undefined;
  return MEASUREMENT_NAMES_BY_CODE[String(code).trim()];
}

/** Name if known, otherwise the code itself — the usual table-cell need. */
export function formatMeasurementCode(
  code: string | number | null | undefined
): string {
  if (code === null || code === undefined || code === "") return "-";
  return getMeasurementName(code) ?? String(code);
}
